<div *ngIf="show" class="modal-wrapper">
    <div class="modal-content" [class.modal-content-large]="large">
        <div class="modal-content-header">
            <button mat-icon-button type="button" class="btn btn-default btn-close" (click)="closeModal()"
                title="Close"><i class="fa fa-times"></i></button>
        </div>
        <ng-content></ng-content>
    </div>
</div>